import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	singleFieldUpdatedContent: {
		id: 'contextual-summary.gadgets.activity-feed.activity-items.attachment-added.single-field-updated-content',
		defaultMessage:
			'{author} updated field "{fieldName}"{newValue, select, undefined {} other { to {newValue}}} on {issueLink}',
		description:
			'Message shape for an activity item describing an custom field being updated on an issue.',
	},
});
